// no need to translate since this is dedicated data for guinee pick3 game
export const CT_PICKS3_DATA_ABOUT = [
    {
        betType: 'ORDRE',
        playerSelection: '3 chiffres de 0 à 9, Répétitions autorisées',
        playerValueDigits: 3,
        playerValueRepetition: '0-9',
        winningCount: 3,
        winningCondition: 'Les 3 chiffres choisis correspondent exactement à l’ordre du tirage',
        wager: 2000,
        multiplier: 650,
        winnings: 1300000,
    },
    {
        betType: 'ORDRE ET DESORDRE',
        playerSelection: '3 chiffres de 0 à 9 distincts, Répétitions non autorisées.',
        playerValueDigits: 3,
        playerValueRepetition: '0-9',
        winningCount: 3,
        winningCondition: 'Les 3 chiffres choisis apparaissent dans le tirage, dans n’importe quel ordre',
        wager: 2000,
        multiplier: 110,
        winnings: 220000,
    },
    {
        betType: 'ORDRE ET DESORDRE AVEC DOUBLE',
        playerSelection: '3 chiffres de 0 à 9 avec 2 chiffres identiques',
        playerValueDigits: 3,
        playerValueRepetition: '0-9',
        winningCount: 3,
        winningCondition: 'Les 3 chiffres choisis apparaissent dans le tirage, dans n’importe quel ordre',
        wager: 2000,
        multiplier: 220,
        winnings: 440000,
    },
    {
        betType: 'DEUX PREMIERS',
        playerSelection: '2 chiffres de 0 à 9, Répétitions autorisées',
        playerValueDigits: 3,
        playerValueRepetition: '0-9',
        winningCount: 2,
        winningCondition: 'Les 2 chiffres choisis correspondent exactement aux 2 premières positions du tirage',
        wager: 2000,
        multiplier: 65,
        winnings: 130000,
    },
    {
        betType: 'DEUX DERNIERS',
        playerSelection: '2 chiffres de 0 à 9, Répétitions autorisées',
        playerValueDigits: 3,
        playerValueRepetition: '0-9',
        winningCount: 2,
        winningCondition: 'Les 2 chiffres choisis correspondent exactement aux 2 dernières positions du tirage',
        wager: 2000,
        multiplier: 65,
        winnings: 130000,
    },
    {
        betType: 'PREMIER ET TROISIEME',
        playerSelection: '2 chiffres de 0 à 9, Répétitions autorisées',
        playerValueDigits: 3,
        playerValueRepetition: '0-9',
        winningCount: 2,
        winningCondition: 'Les 2 chiffres choisis correspondent exactement aux positions 1 et 3 du tirage',
        wager: 2000,
        multiplier: 65,
        winnings: 130000,
    },
    // {
    //     betType: '2 out of 3 (at least 2)',
    //     playerSelection: 'Sequence of [digits] digits ([repetition], repetition allowed)',
    //     playerValueDigits: 3,
    //     playerValueRepetition: '0-9',
    //     winningCount: 2,
    //     winningCondition: 'At least [count] of the chosen numbers appear in the draw',
    //     wager: 2000,
    //     multiplier: 5,
    //     winnings: 10000,
    // },
]
